<template>
  <div id="calculator" class="section_category">
    <div class="container_category">
      <div class="box_category">
        <h2 class="title_category">
          <span class="color_orange">ПОЛУЧИТЬ ПРЕДВАРИТЕЛЬНЫЙ РАССЧЕТ </span
          ><br />
          ЖЕЛАЕМОЙ МЕБЕЛИ ЗА 5 МИНУТ
        </h2>
        <div class="box_sub_text_category">
          <!-- <p class="sub_text_category">
            Узнайте примерную стоимость мебели с помощью нашего калькулятора.
            Просто введите параметры комнаты и получите предполагаемую оценку
            расходов.
          </p> -->
        </div>
      </div>
      <button class="submit-button" @click="submitSelection">
        <span>РАССЧИТАТЬ</span>
      </button>
    </div>
    <div class="options">
      <div
        class="category"
        v-for="(items, category) in options"
        :key="category"
      >
        <h3>{{ category }}</h3>
        <div class="buttons">
          <label v-for="item in items" :key="item.label" class="option-label">
            <span class="text_category">{{ item.label }}</span>
            <input
              type="radio"
              :name="category"
              :value="item.label"
              @click="toggleSelection(category, item.label)"
            />
            <div
              class="box_custom-radio"
              :class="{ active: selectedOptions[category] === item.label }"
            >
              <span
                class="custom-radio"
                :class="{ active: selectedOptions[category] === item.label }"
              ></span>
            </div>
          </label>
        </div>
      </div>
    </div>
    <button class="submit-button_m" @click="submitSelection">
      <span>РАССЧИТАТЬ</span>
    </button>
  </div>
</template>

<script>
import { useCartStore } from "@/store/cartStore";
import { ref } from "vue";

export default {
  setup() {
    const cartStore = useCartStore();
    const selectedOptions = ref({});

    const toggleSelection = (category, label) => {
      selectedOptions.value = {
        ...selectedOptions.value,
        [category]: selectedOptions.value[category] === label ? null : label,
      };
    };

    const submitSelection = () => {
  cartStore.selectedOptions = selectedOptions.value;
  cartStore.setHideCategoriesBlock(true); // ⬅️ Скрываем блок
  cartStore.toggleCart();
};


    return {
      selectedOptions,
      toggleSelection,
      submitSelection,
      toggleCart: cartStore.toggleCart,
      options: {
        МЕБЕЛЬ: [
          { label: "Кухни" },
          { label: "Гардеробная" },
          { label: "Шкаф" },
          { label: "Прихожая" },
          { label: "Гостинная" },
          { label: "Спальня" },
          { label: "Спальня" },
          { label: "Для бизнеса" },
        ],
        МАТЕРИАЛЫ: [
          { label: "ЛДСП" },
          { label: "МДФ" },
          { label: "ПЛАСТИК" },
          { label: "ЭМАЛЬ" },
        ],
        СРОКИ: [
          { label: "Как можно быстрее" },
          { label: "В течении 2-3 месяцев" },
          { label: "В течении 6 месяцев" },
        ],
        // СЕГМЕНТ: [{ label: "Премиум" }, { label: "Стандартный" }],
      },
    };
  },
};
</script>

<style scoped>
.submit-button_m {
  display: none;
}
.options {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 40rem;
}
.category {
  display: flex;
  padding: 1.5rem 0px;
  justify-content: space-between;
  border-top: 0.05rem solid rgb(255, 255, 255);
}
.category:last-child {
  border-bottom: 0.05rem solid rgb(255, 255, 255);
}
.text_category {
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.4rem;
  letter-spacing: 0%;
  text-align: left;
}
.category h3 {
  color: rgb(245, 160, 62);
  font-family: Roboto;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.4rem;
  letter-spacing: -1%;
  text-align: left;
  text-transform: uppercase;
}
.buttons {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}
.option-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 26.7rem;
}
.option-label input {
  display: none;
}
.custom-radio {
  width: 0.9rem;
  height: 0.9rem;
  border: 0.05rem solid rgb(255, 255, 255);
  border-radius: 50%;
  display: inline-block;
  position: relative;
  transition: 0.2s ease;
}
.custom-radio.active {
  background: rgb(245, 160, 62);
  border: 0.05rem solid rgb(245, 160, 62);
  transition: 0.2s ease;
}
.box_custom-radio {
  width: 1.4rem;
  height: 1.4rem;
  border: 0.05rem solid rgb(255, 255, 255);
  border-radius: 0.4rem;
  padding: 0.2rem;
  transition: 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.box_custom-radio.active {
  border: 0.05rem solid rgb(245, 160, 62);
  transition: 0.2s ease;
}
.section_category {
  padding: 7rem 8rem;
  display: flex;
  justify-content: space-between;
}
.container_category {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}
.title_category {
  font-family: Roboto;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.9rem;
  letter-spacing: -1.5%;
  text-align: left;
  color: rgb(255, 255, 255);
}
.box_sub_text_category {
  width: 26.6rem;
}
.sub_text_category {
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.4rem;
  letter-spacing: 0%;
  text-align: left;
}
.box_category {
  display: flex;
  flex-direction: column;
  gap: 3rem;
}
.submit-button {
  border-radius: 4rem;

  background: linear-gradient(
    90deg,
    rgb(245, 160, 62),
    rgb(207, 117, 14) 102.477%
  );
  height: 3rem;
  width: 100%;
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.4rem;
  letter-spacing: 0%;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
}
.submit-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: -150%;
  width: 150%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 204, 102, 0) 0%,
    rgba(255, 204, 102, 0.9) 50%,
    rgba(255, 204, 102, 0) 100%
  );
  filter: blur(4px);
  animation: wave 2s infinite linear;
  z-index: 0;
}

.submit-button span {
  color: rgb(255, 255, 255);
  position: relative;
  z-index: 1;
}
@media (max-width: 767px) {
  .section_category {
    padding: 1.7rem 2.4rem 4rem 2.4rem;
    flex-direction: column;
    gap: 3rem;
  }
  .options,
  .option-label,
  .buttons {
    width: 100%;
  }
  .options {
    gap: 2.65rem;
  }
  .category {
    position: relative;
    width: 100%;
  }
  .submit-button {
    display: none;
  }
  .category h3 {
    position: absolute;
    top: -1.5rem;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.14rem;
  }
  .text_category {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.14rem;
  }
  .box_custom-radio {
    width: 1.64rem;
    height: 1.64rem;
  }
  .custom-radio {
    width: 1.07rem;
    height: 1.07rem;
  }
  .submit-button_m {
    display: flex;
    width: 16.5rem;
    height: 2.71rem;
    border-radius: 5.71rem;
    background: linear-gradient(
      90deg,
      rgb(245, 160, 62),
      rgb(207, 117, 14) 102.477%
    );
    color: rgb(255, 255, 255);
    font-family: Roboto;
    font-size: 0.71rem;
    font-weight: 700;
    line-height: 0.86rem;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
  }

  .submit-button_m::before {
    content: "";
    position: absolute;
    top: 0;
    left: -150%;
    width: 150%;
    height: 100%;
    background: linear-gradient(
      90deg,
      rgba(255, 204, 102, 0) 0%,
      rgba(255, 204, 102, 0.9) 50%,
      rgba(255, 204, 102, 0) 100%
    );
    filter: blur(4px);
    animation: wave 2s infinite linear;
    z-index: 0;
  }

  .submit-button_m span {
    color: rgb(255, 255, 255);
    position: relative;
    /* z-index: 1; */
  }
  .title_category {
    font-size: 1.43rem;
    font-weight: 700;
    line-height: 1.64rem;
  }
  .box_sub_text_category {
    width: 100%;
  }
  .box_category {
    gap: 1.5rem;
  }
}
</style>
